import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

	{
		path: '/talent',
		name: 'talent',
		component: () => import('../views/talent/index.vue'),
		meta: { showHeaderAvatar: true }
	},
	// {
	// 	path: '/pool',
	// 	name: 'pool',
	// 	component: () => import('../views/talent/index.vue'),
	// 	meta: { showHeaderAvatar: true }
	// },
	{
		path: '/',
		name: 'index',
		redirect: '/store/entry',
	},

	{
		path: '/position',
		name: 'position',
		component: () => import('../views/position/index.vue'),
		meta: { showHeaderAvatar: true }
	},
	{
		path: '/chating',
		name: 'chating',
		component: () => import('../views/chating/index.vue'),
		meta: { showHeaderAvatar: true }
	},
	{
		path: '/detail/:id',
		name: 'detail',
		component: () => import('../views/detail/index.vue'),
	},
/* 	{
		path: '/demo',
		name: 'demo',
		component: () => import('../views/demo/index.vue'),
		meta: { showHeaderAvatar: true }
	}, */
	{
		path: '/404',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/store',
		component: () => import('../views/store.vue'),
		// redirect: "store/entry",
		redirect: "store/entry",
		children: [{
				path: 'entry',
				component: () => import('../views/entry/index.vue'),
				redirect: "entry/loginEmail",
				children: [{
						path: 'loginEmail',
						component: () => import('../views/entry/loginEmail/index.vue'),
					},
					{
						path: 'loginPwd',
						component: () => import('../views/entry/loginPwd/index.vue'),
					},
					{
						path: 'loginQRCode',
						component: () => import('../views/entry/loginQRCode/index.vue'),
					},
					{
						path: 'forgottenPwd',
						component: () => import('../views/entry/forgottenPwd/index.vue'),
					},
					{
						path: 'verifyCompany',
						component: () => import('../views/entry/verifyCompany/index.vue'),
					},

				]
			},
			{
				path: 'dashboard',
				component: () => import('../views/dashboard/index.vue'),
				redirect: "dashboard/profile",
				children: [{
						path: 'profile',
						component: () => import('../views/dashboard/profile/index.vue'),
					},
					{
						path: 'QRCode',
						component: () => import('../views/dashboard/QRCode/index.vue'),
					},
					{
						path: 'phone',
						component: () => import('../views/dashboard/phone/index.vue'),
					},
					{
						path: 'password',
						component: () => import('../views/dashboard/password/index.vue'),
					},
				]
			},

			{
				path: 'email',
				component: () => import('../views/email/index.vue'),
				redirect: "email/verify",
				children: [{
					path: 'verify',
					component: () => import('../views/email/verify/index.vue'),
				}, ]
			},
			{
				path: 'socialInsurance',
				component: () => import('../views/socialInsurance/index.vue'),
				redirect: "socialInsurance/verify",
				children: [{
					path: 'verify',
					component: () => import('../views/socialInsurance/verify/index.vue'),
				}, ]
			},
			{
				path: 'onTheJob',
				component: () => import('../views/onTheJob/index.vue'),
				redirect: "onTheJob/verify",

			},
		]
	},
	{
		path: '/verifyCompany',
		component: () => import('../views/verifyCompany/index.vue'),
		redirect: "/verifyCompany/businessVerification",
		children: [{
			path: 'businessVerification',
			component: () => import('../views/verifyCompany/businessVerification/index.vue'),
		}, {
			path: 'businessVerificationFunc',
			component: () => import('../views/verifyCompany/businessVerificationFunc/index.vue'),
		}, {
			path: 'email',
			component: () => import('../views/verifyCompany/email/index.vue'),

		}, {
			path: 'onTheJob',
			component: () => import('../views/verifyCompany/onTheJob/index.vue'),

		},{
			path: 'businessLicense',
			component: () => import('../views/verifyCompany/businessLicense/index.vue'),
		},{
			path: 'invitationCode',
			component: () => import('../views/verifyCompany/invitationCode/index.vue'),
		},
		 {
			path: 'socialInsurance',
			component: () => import('../views/verifyCompany/socialInsurance/index.vue'),
			redirect: "/verifyCompany/socialInsurance/verify",
			children: [{
				path: 'verify',
				component: () => import('../views/verifyCompany/socialInsurance/verify/index.vue'),
			}]
		}]
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: () => import('../views/dashboard/index.vue'),
	},
	{
		path: '*',
		redirect: '/404'
	}
]

const router = new VueRouter({
	mode: 'history',
	// base: process.env.BASE_URL,
	base: process.env.NODE_ENV === 'production' ? '' : '/',
	routes
})

export default router